var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluetooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.139 15.2309L12.0618 10.9999L17.139 6.76884C17.6187 6.36913 17.6187 5.63239 17.139 5.23268L11.1401 0.233532C10.4889 -0.309155 9.50016 0.153924 9.50016 1.00164V8.58611L6.20782 5.29377C5.81734 4.90329 5.18431 4.90329 4.79383 5.29377C4.40336 5.68424 4.40336 6.31728 4.79383 6.70775L9.08597 10.9999L4.79383 15.292C4.40336 15.6825 4.40336 16.3155 4.79383 16.706C5.18431 17.0965 5.81734 17.0965 6.20782 16.706L9.50016 13.4137V20.9981C9.50016 21.8458 10.4888 22.3089 11.1401 21.7662L17.139 16.7671C17.6187 16.3673 17.6187 15.6306 17.139 15.2309ZM11.4998 3.13625L14.9372 6.0007L11.4998 8.86514V3.13625ZM11.4998 18.8634V13.1345L14.9372 15.999L11.4998 18.8634Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.874db5a5.svg";
export { ForwardRef as ReactComponent };